import { Inject, Injectable } from '@angular/core';
import { filter, sortBy } from 'lodash';
import { IUserMiniWithRole } from '../../typings/interfaces/user.interface';
import { ImUser } from './../im-models/im-user';

@Injectable()
export class PointPeopleService {
  constructor(private imUser: ImUser, @Inject('Rollbar') private rollbar) {}

  // filters for users that can be assigned as flag point people
  filterForUsersThatCanBeFlagPp(users: IUserMiniWithRole[]) {
    const filteredUsers = filter(users, (user: IUserMiniWithRole) => {
      if (this.imUser.isClusterUser(user)) {
        this.rollbar.error(
          '"PointPeopleService#filterForUsersThatCanBeFlagPp" should NOT be called on cluster users! ' +
            `It was called on user "${user._id}".`,
        );
        return false;
      }

      const validPp = this.imUser.isEditingUser(user);

      return validPp;
    });
    const sortedFilteredUsers = sortBy(filteredUsers, user => {
      return user.name.firstName;
    });

    return sortedFilteredUsers;
  }

  // filters for users that can be assigned as non flag point people (e.g. advisor, guidance counselor)
  filterForUsersThatCanBeNonFlagPp(users: IUserMiniWithRole[]) {
    const filteredUsers = filter(users, (user: IUserMiniWithRole) => {
      if (this.imUser.isClusterUser(user)) {
        this.rollbar.error(
          '"PointPeopleService#filterForUsersThatCanBeNonFlagPp" should NOT be called on cluster users! ' +
            `It was called on user "${user._id}".`,
        );
        return false;
      }

      const validPp = !this.imUser.isNoAccessUser(user);

      return validPp;
    });
    const sortedFilteredUsers = sortBy(filteredUsers, user => {
      return user.name.firstName;
    });

    return sortedFilteredUsers;
  }
}
